import { render, staticRenderFns } from "./SuccessfulModal.vue?vue&type=template&id=0225a1cd"
import script from "./SuccessfulModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports